import React from "react";
import { Button } from "antd";
import { HomeOutlined, ReloadOutlined } from "@ant-design/icons";
import { isChunkLoadError } from "../../utils/errorUtils";
import ErrorIllustration from "./ErrorIllustration";
import styles from "./ErrorFallbackView.module.css";

type ErrorFallbackViewProps = {
  error: unknown;
  onRefresh: () => void;
  onGoHome?: () => void;
};

const ErrorFallbackView: React.FC<ErrorFallbackViewProps> = ({
  error,
  onRefresh,
  onGoHome,
}) => {
  const chunkError = isChunkLoadError(error);

  const title = chunkError
    ? "We couldn't load this page"
    : "Oops! Something went wrong";

  const message = chunkError
    ? "Don't worry — this happens sometimes. Please refresh the page and try again."
    : "We're sorry for the inconvenience. Please try again, or return to the home page.";

  return (
    <div className={styles.page}>
      <div className={styles.content}>
        <div className={styles.illustrationWrap}>
          <ErrorIllustration className={styles.illustration} />
        </div>

        <h1 className={styles.title}>{title}</h1>
        <p className={styles.message}>{message}</p>

        <div className={styles.actions}>
          <Button
            type="primary"
            icon={<ReloadOutlined />}
            onClick={onRefresh}
            className={styles.primaryButton}
          >
            Try again
          </Button>

          {!chunkError && onGoHome ? (
            <Button
              icon={<HomeOutlined />}
              onClick={onGoHome}
              className={styles.secondaryButton}
            >
              Go to home
            </Button>
          ) : null}
        </div>
      </div>
    </div>
  );
};

export default ErrorFallbackView;
